import { useContext } from "react";
import { QCContext } from "./QCContextProvider";
export var useQCStateContext = function () { return useContext(QCContext); };
export var useQCDispatch = function () {
    var dispatch = useQCStateContext().dispatch;
    return dispatch;
};
